export enum EnumIndStatusMovPag {
    EmAberto = 0,
    Recusado = 1,
    Processando = 2,
    Aprovado = 3,
}